import React, { useState ,useEffect } from "react";
import { usePagination } from "./pagination-hook";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
// import "./Pagination.css"
import { Col, Form, Row } from "react-bootstrap";
import SearchSelect from "../common/SearchSelect";
import { PAGINATION_COUNT } from "../../utils/constant";

export default function Pagination(props) {
  const { setCurrentPage, totalCount, currentPage, pageSize, sessionName,setPageSize, totalCount1 } = props;
  const [errors, setErrors] = useState({});
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    pageSize,
  });

  let lastPage = paginationRange?.totalPageCount;
  let pageText = `${paginationRange?.startInd}-${paginationRange?.endInd} of ${totalCount} ${props.dataType}`;

  const onNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else {
      setCurrentPage(1);
    }
  };
  const totalPages = Math.ceil(totalCount/pageSize);
  
  const rowsDisplayed = Math.min(pageSize, totalCount - (currentPage - 1) * pageSize);


  const handlePageChange = (page) => {
    if (page < 1) {
      setCurrentPage(1);
    } else if (page > totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(page);
    }
  };

  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1); 
  };
  const startInd = (currentPage - 1) * pageSize + 1;
  const endInd = Math.min(currentPage * pageSize, totalCount);

// const totalCountArray = Array.from({ length: totalCount }, (_, i) => i + 1);
// const totalCountArray = Array.from({ length: 10}, (_, i) => ((i+1)*5));

const totalCountOptions = PAGINATION_COUNT.map((Type) => (
  <option key={Type} value={Type}>
    {Type}
  </option>
));
  return (
    <div className="pagination">
      
      {/* <span className="pageSize">{rowsDisplayed} {props.sessionName}</span> */}
      <span className="pageSize">
        {"Records per page: "}
        </span>
        <span className="pagination-select">
        <SearchSelect
          name="pagesize"
          value={pageSize}
          option={totalCountOptions}
          fieldName="pagesize"
          onChange={handlePageSizeChange}
          setError={setErrors}
        >
         
        </SearchSelect>
      </span>
      <span className="pageSize">{startInd}-{endInd} of {totalCount}</span>
      <span className="pagination-prev">
      <ChevronLeft
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        // className="pagination-arrow"
        className={`pagination-arrow ${currentPage === 1 ? "pagination-disabled-button" : ""}`}
      />
        </span>
        <span className="pagination-next">

        {/* Prev */}
      
      {/* <span className="currentPage">{currentPage}</span> */}
      <ChevronRight
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        // className="pagination-arrow"
        className={`pagination-arrow ${currentPage === totalPages ? "pagination-disabled-button" : ""}`}
      />
      </span>
        
        {/* Next */}
      
      {/* <span className="pageSize">of {totalPages} pages</span> */}
    </div>
  );
}
